export default "__VITE_ASSET__CLPago6g__"